import { initialState } from './reducers'

export const select = (state) => state || initialState

export const selectAdjectiveRemixState = (state) => select(state).adjectiveRemix?.adjectiveRemixState
